import { useEffect } from 'react';
import useInterval from '../../../hooks/useInterval';

// start and stop in dependency array would make interval restart constantly
const useAutoplay = (autoplay: number = 0, actionToCall: () => void) => {
  const [start, stop] = useInterval(autoplay * 1000, actionToCall);
  useEffect(() => {
    if (autoplay) start();
    return () => {
      stop();
    };
  }, [autoplay, stop, start]);
  return [start, stop];
};

export default useAutoplay;
